/**
 * Parses "YYYY-MM-DD" (or ISO string starting with it) into a local Date at midnight.
 * Returns null for invalid inputs.
 */
export const parseYmdToLocalDate = (value) => {
  if (value == null) return null;
  const s = String(value).trim().slice(0, 10);
  const [y, m, d] = s.split("-").map(Number);
  if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) return null;
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
};

